import { registerRules } from "./registry";
import { designErrorRules } from "./rules/design-errors";
import { contentRecommendationRules } from "./rules/content-recommendations";
import { designRecommendationRules } from "./rules/design-recommendations";
import { logicRecommendationRules } from "./rules/logic-recommendations";
import { existingBlockingRules } from "./rules/existing-blocking";

/**
 * Single registration point. Importing this module registers every rule, so the
 * builder only ever imports `@/validation`.
 */
let registered = false;

export const initValidationRules = (): void => {
  if (registered) return;
  registerRules(existingBlockingRules);
  registerRules(designErrorRules);
  registerRules(designRecommendationRules);
  registerRules(contentRecommendationRules);
  registerRules(logicRecommendationRules);
  registered = true;
};

initValidationRules();

export { buildContext, assetTypeOf, elementKeyFor } from "./context";
export type { ContextSource } from "./context";
export { allRules, getRule, rulesFor, runRules } from "./registry";
export type {
  AssetType,
  BuilderContext,
  BuilderSection,
  ContextElement,
  RuleResult,
  RuleTarget,
  Severity,
  ValidationRule,
} from "./types";
